import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import api from '../../../../config/axios';
import Paginacao from '../../../../components/utils/paginacao';

import { FaTimes, FaFilter } from 'react-icons/fa';

const OperacoesCaixaModal = ({ onClose, caixa, activeTab }) => {
    const [operacoes, setOperacoes] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [filtroTipoOperacao, setFiltroTipoOperacao] = useState('');

    useEffect(() => {
        fetchOperacoes();
    }, [currentPage]);

    const fetchOperacoes = async () => {
        try {
            Swal.fire({
                title: "Carregando...",
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const params = `page=${currentPage}&limit=10${filtroTipoOperacao ? `&tipo_operacao=${filtroTipoOperacao}` : ''}`;
            const response = await api.get(`/caixas/${caixa.id}/operacoes?${params}`);
            setOperacoes(response.data.records || []);
            setTotalPages(response.data.totalPages || 1);

            Swal.close();
        } catch (error) {
            Swal.close();
            Swal.fire('Erro', 'Erro ao carregar operações do caixa', 'error');
        }
    };

    const tiposOperacao = {
        'abertura': 'Abertura',
        'fechamento': 'Fechamento',
        'reabertura': 'Reabertura',
        'pagamento_dinheiro': 'Pagamento em dinheiro',
        'pagamento_credito': 'Pagamento com cartão de crédito',
        'pagamento_debito': 'Pagamento com cartão de débito',
        'pagamento_pix': 'Pagamento via PIX',
        'pagamento_boleto': 'Pagamento via boleto',
        'pagamento_ted': 'Pagamento via TED',
        'pagamento_doc': 'Pagamento via DOC',
        'uso_cortesia': 'Uso de cortesia',
        'sangria': 'Retirada de Dinheiro',
        'suprimento': 'Entrada de Dinheiro'
    };

    const formatTipoOperacao = (tipo) => {
        return tiposOperacao[tipo] || tipo;
    };

    const handleFiltrar = () => {
        setCurrentPage(1);
        fetchOperacoes();
    };

    const handleLimparFiltro = () => {
        setFiltroTipoOperacao('');
        setCurrentPage(1);
    };

    return (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-header">
                        <h4 className="fw-bold mt-2">
                            Operações do Caixa
                        </h4>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>

                    <div className="modal-body">
                        <div className="row">
                            <div className="col-12">
                                <p className="mb-2">
                                    <strong>Responsável:</strong> {caixa.colaborador.nome}
                                </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <p className="mb-2">
                                    <strong>Data de Abertura:</strong> {new Date(caixa.data_abertura).toLocaleString('pt-BR').replace(',', '')}
                                </p>
                            </div>
                        </div>
                        {activeTab === 'historico' && caixa.data_fechamento && (
                            <div className="row">
                                <div className="col-12">
                                    <p className="mb-2">
                                        <strong>Data de Fechamento:</strong> {new Date(caixa.data_fechamento).toLocaleString('pt-BR').replace(',', '')}
                                    </p>
                                </div>
                            </div>
                        )}

                        <div className="row mt-3">
                            <div className="col-lg-4 col-12">
                                <label className="form-label fw-bold">Filtrar por Tipo de Operação</label>
                                <select
                                    className="form-select"
                                    value={filtroTipoOperacao}
                                    onChange={(e) => setFiltroTipoOperacao(e.target.value)}
                                >
                                    <option value="">Todos</option>
                                    {Object.entries(tiposOperacao).map(([valor, label]) => (
                                        <option key={valor} value={valor}>
                                            {label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-lg-8 col-12 mt-lg-0 mt-3 d-flex align-items-end">
                                <div className="d-flex gap-2 w-100 justify-content-end">
                                    <button
                                        className="btn btn-outline-secondary"
                                        onClick={handleLimparFiltro}
                                    >
                                        Limpar
                                    </button>
                                    <button
                                        className="btn btn-custom-primary"
                                        onClick={handleFiltrar}
                                    >
                                        <FaFilter /> Filtrar
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="row mt-4">
                            <div className="col-12">
                                <div className="table-responsive">
                                    <table className="table table-striped table-hover">
                                        <thead className="table-dark">
                                            <tr>
                                                <th className="text-nowrap">Data e Hora</th>
                                                <th className="text-nowrap">Tipo de Operação</th>
                                                <th className="text-nowrap">Valor</th>
                                                <th>Descrição</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(operacoes.map((operacao) => (
                                                <tr key={operacao.id}>
                                                    <td className="text-nowrap">
                                                        {new Date(operacao.data_hora).toLocaleString('pt-BR').replace(',', '')}
                                                    </td>
                                                    <td className="text-nowrap">{formatTipoOperacao(operacao.tipo_operacao)}</td>
                                                    <td className="text-nowrap">
                                                        {parseFloat(operacao.valor).toLocaleString('pt-BR', {
                                                            style: 'currency',
                                                            currency: 'BRL'
                                                        })}
                                                    </td>
                                                    <td className="text-nowrap">{operacao.descricao || '-'}</td>
                                                </tr>
                                            ))
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="d-flex justify-content-end mt-4">
                                  <Paginacao
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    onPageChange={setCurrentPage}
                                  />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button type="button" className="btn btn-outline-danger" onClick={onClose}>
                            <FaTimes className="me-1" />
                            Fechar
                        </button>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default OperacoesCaixaModal; 